// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isWithinInterval as fn } from "../isWithinInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isWithinIntervalWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default isWithinIntervalWithOptions;
